import { Pie } from 'vue-chartjs'
 
export default {
	extends: Pie,
	props : [ 'providers_status' ],
	data: function(){
		return {
			data : {
	                labels: ["in-progress", "awaiting", "approved"],
	                colors: ["#00777b", "#11a5a7", "#053f41"],
	                opacityColors: ["#00777b", "#11a5a7", "#053f41"],
			      datasets: [
			        {
			          label: '',
			          backgroundColor: ["#00777b", "#11a5a7", "#053f41"],
			          data: this.providers_status
			        }
			      ]
              },
            options:{
	            /*onClick:function(evt){
		            console.log(evt);
	                var activePoints = this.getElementsAtEvent(evt);
		            var firstPoint = activePoints[0];
					var label = this.data.labels[firstPoint._index];
					alert('This will filter '+label+ ' Programs ');
					
	            },*/
	            onClick: function(evt, activeElements) {
			      var elementIndex = activeElements[0]._index;
			      var bars = this.data.datasets[0].backgroundColor;
			      for (var i = 0; i < bars.length; i+=1) {
				      if( i == elementIndex){
					  	this.data.datasets[0].backgroundColor[i] = this.data.colors[i];
					  }else{
					  	this.data.datasets[0].backgroundColor[i] = this.data.opacityColors[i];
					  }
					}
			      
			      this.update();
			     },
	            responsive: true,
	            tooltips: {
				    callbacks: {
				      label: function(tooltipItem, data) {
				        var dataset = data.datasets[tooltipItem.datasetIndex];
				        var currentValue = dataset.data[tooltipItem.index];
				        return currentValue;
				      },
				      title: function(tooltipItem, data) {
				        return data.labels[tooltipItem[0].index];
				      }
				    }
				  }
	        },
	        chart : null
		}
	},
	mounted () {
		var colors = this.data.colors;
		
		var opacityColors = this.data.opacityColors;
		
		colors.forEach(function(key, value){
			var c;
	        c= key.substring(1).split('');
	        if(c.length== 3){
	            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
	        }
	        c= '0x'+c.join('');
	         opacityColors[value] = 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',.2)';
		});
		
		var vue_instance = this;

		this.options.onClick = function(evt, activeElements) {
    		
			var elementIndex = activeElements[0]._index;
			var bars = this.data.datasets[0].backgroundColor;
			for (var i = 0; i < bars.length; i+=1) {
				if( i == elementIndex){
					this.data.datasets[0].backgroundColor[i] = this.data.colors[i];
				}else{
					this.data.datasets[0].backgroundColor[i] = this.data.opacityColors[i];
				}
			}

			var activePoints = this.getElementsAtEvent(evt);
			var firstPoint = activePoints[0];
			var label = this.data.labels[firstPoint._index];

			vue_instance.graphicFilter(label);	
		}
		this.chart = this.renderChart(this.data, this.options)
	},
	methods : {
		graphicFilter : function(filter){
			console.log("APLICAR FILTRO", filter);

			this.$emit('filterApplied', filter);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/charts/CompletionPieChart.js